import { connect, MapStateToProps } from 'react-redux';
import { Props } from './FolderPaywall';
import {
  isCurrentUserProfileOwner,
  isViewingAsVisitor,
} from '../../../../selectors/users';
import { AppState } from '../../../../../types/store';

type StateProps = Pick<
  Props,
  'isCurrentUserProfileOwner' | 'isViewingAsVisitor'
>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
  isViewingAsVisitor: isViewingAsVisitor(state),
});

export default connect(mapStateToProps);
